import api from './api';

export interface KeyPerson {
  name: string;
  role_title?: string;
  email?: string;
  phone?: string;
}

export interface Supplier {
  id: number;
  name: string;
  domain?: string;
  cnpj?: string;
  contact_email?: string;
  contact_phone?: string;
  notes?: string;
  key_people?: KeyPerson[];
  is_active: boolean;
  created_at: string;
}

export interface SupplierCreate {
  name: string;
  domain?: string;
  contact_email?: string;
  contact_phone?: string;
  cnpj?: string;
  notes?: string;
  key_people?: KeyPerson[];
  is_active?: boolean;
}

export interface SupplierUpdate {
  name?: string;
  domain?: string;
  contact_email?: string;
  contact_phone?: string;
  cnpj?: string;
  notes?: string;
  key_people?: KeyPerson[];
  is_active?: boolean;
}

export const suppliersService = {
  async getAll(): Promise<Supplier[]> {
    const response = await api.get('/api/v2/suppliers/');
    return response.data;
  },

  async getActive(): Promise<Supplier[]> {
    const response = await api.get('/api/v2/suppliers/active');
    return response.data;
  },

  async getById(id: number): Promise<Supplier> {
    const response = await api.get(`/api/v2/suppliers/${id}`);
    return response.data;
  },

  async create(supplier: SupplierCreate): Promise<Supplier> {
    const response = await api.post('/api/v2/suppliers/', supplier);
    return response.data;
  },

  async update(id: number, supplier: SupplierUpdate): Promise<Supplier> {
    const response = await api.put(`/api/v2/suppliers/${id}`, supplier);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/api/v2/suppliers/${id}`);
  },

  async listIntel(supplierId: number): Promise<SupplierIntelItem[]> {
    const response = await api.get(`/api/v2/suppliers/${supplierId}/intel`);
    return response.data;
  },

  async createIntel(supplierId: number, items: SupplierIntelCreate[]): Promise<SupplierIntelItem[]> {
    const response = await api.post(`/api/v2/suppliers/${supplierId}/intel`, items);
    return response.data;
  },

  async reassignCompany(supplierId: number, company_id: number): Promise<Supplier> {
    const response = await api.post(`/api/v2/suppliers/${supplierId}/reassign`, { company_id });
    return response.data;
  }
};

export interface SupplierIntelCreate {
  title: string;
  summary?: string;
  source?: string;
  url?: string;
  severity?: string;
  published_at?: string; // ISO string
}

export interface SupplierIntelItem extends SupplierIntelCreate {
  id: number;
  supplier_id: number;
  company_id: number;
  created_at: string;
}
